import Blue from "~/core";

new Blue({
  name: "Holiday Closing",
  selector: ".holiday",
  setup(holiday) {
    if (holiday.classList.contains("holiday--stacked")) {
      const containers = holiday.querySelectorAll(".holiday__container");

      const calculateTextOverflow = () => {
        containers.forEach(container => {
          const location = container.querySelector(".holiday__location");
          const locationWidth = location.offsetWidth;

          if (container.offsetWidth <= 500) {
            removeViewMoreButton(container);
            location.classList.remove("holiday__location--text-overflow");
            return;
          }

          const WIDTH_DIVISOR = 5.4;
          /* After testing break points, this seems to be the best ratio for character size compared to width */

          const locationWidthInCharacters = Math.floor(
            locationWidth / WIDTH_DIVISOR
          );
          const locationCharacters = location.textContent.length;

          if (locationCharacters >= locationWidthInCharacters) {
            location.classList.add("holiday__location--text-overflow");
            addViewMoreBUtton(container);
          } else if (locationCharacters < locationWidthInCharacters) {
            location.classList.remove("holiday__location--text-overflow");
            removeViewMoreButton(container);
          }
        });
      };

      const addViewMoreBUtton = container => {
        if (container.querySelector(".holiday__view-more")) {
          return;
        }
        const viewMoreButton = document.createElement("button");
        viewMoreButton.classList.add("holiday__view-more");
        viewMoreButton.textContent = "View More";
        viewMoreButton.setAttribute("type", "button");
        viewMoreButton.addEventListener(
          "click",
          viewMore.bind(null, container)
        );
        container.appendChild(viewMoreButton);
      };

      const removeViewMoreButton = container => {
        if (!container.querySelector(".holiday__view-more")) {
          return;
        }
        const viewMoreButton = container.querySelector(".holiday__view-more");
        viewMoreButton.removeEventListener("click", viewMore);
        container.removeChild(viewMoreButton);
      };

      const viewMore = container => {
        container.classList.toggle("holiday__container--expanded");
      };

      calculateTextOverflow();

      window.addEventListener("resize", calculateTextOverflow);
    }
  }
});
